import { fetchData } from "../../utils/Http"
import { serverUrl } from "../../utils/Settings"

type Request = Hotelstouch.WebApp.WebShop.Api.SendUserMessage.Request
type Response = Hotelstouch.WebApp.WebShop.Api.SendUserMessage.Response

export async function saveUserMessage(params:Request):Promise<Response>{
    return await fetchData<Response>(`${serverUrl}/api/publicWebShop/sendUserMessage`, params)
}